import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTimelinePlay = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.5 5V19L17.5 12L6.5 5Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgTimelinePlay);
export { ForwardRef as ReactComponent };
